module.exports = __webpack_public_path__ + "img/7_en.ccaa8a12.png";